"use client";

import { useMuted, useVolume } from "@/contexts/studio-context";
import { Group, Line, SectionHeader, Slider, StubPicker } from "./atoms";
import { SET } from "./palette";
import { VolumeIcon, VolumeOffIcon } from "@/components/ui/atoms/icons";

export function OutputSection() {
  const [volume, setVolume] = useVolume();
  const [muted, setMuted] = useMuted();

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <SectionHeader kicker="Sortie audio" />

      <Group>
        <Line
          withDivider={false}
          label="Volume global"
          hint={muted ? "Sortie coupée" : "Niveau de sortie"}
          control={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <button
                type="button"
                onClick={() => setMuted(!muted)}
                title={muted ? "Réactiver le son" : "Couper le son"}
                aria-pressed={muted}
                style={{
                  width: 28,
                  height: 24,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: muted ? "rgba(248,113,113,0.10)" : "transparent",
                  border: `1px solid ${muted ? "rgba(248,113,113,0.35)" : SET.border}`,
                  borderRadius: 6,
                  color: muted ? SET.red : SET.textDim,
                  cursor: "pointer",
                  padding: 0,
                  transition: "color 150ms, background 150ms, border-color 150ms",
                }}
              >
                {muted ? <VolumeOffIcon size={14} /> : <VolumeIcon size={14} />}
              </button>

              <Slider value={volume} onChange={setVolume} disabled={muted} />

              <span
                style={{
                  fontSize: 11,
                  color: SET.textMute,
                  minWidth: 28,
                  textAlign: "right",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {muted ? ", " : volume}
              </span>
            </div>
          }
        />
        <Line
          label="Périphérique"
          hint="Sortie audio par défaut du navigateur"
          control={<StubPicker label="Sortie système (par défaut)" />}
        />
      </Group>
    </section>
  );
}
